import React, { useEffect, useContext, useState } from 'react';
import { Button, Dialog } from '@material-ui/core';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise/dist/styles/ag-grid.css';
import 'ag-grid-enterprise/dist/styles/ag-theme-balham.css';
import * as moment from "moment";
import { makeStyles } from '@material-ui/core/styles';
import { AllProjectsContext } from './../AllProjectsContext';
import CustomPinnedRowRenderer from './CustomPinnedRowRenderer';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflow: 'hidden'
  },
  author: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(1)
  },
  table: {

  },
  header: {
    fontSize: '1rem'
  },
  gridContainer:{
    height: '100%'
  }
}));

let gridApi = null;

export default function BudgetSessionsDialog(props) {
  const classes = useStyles();
  const [isDialog, setIsDialog] = useState(false);

  const {
    state,
    getSpecularProjectsAsync
  } = useContext(AllProjectsContext);

  const {
    specularProjects,
    lookUpData
  } = state;

  function closeDialog() {
    gridApi.destroy();
    setIsDialog(false);
  }
  
  let eInput = null;
  const [columnDefs, setColumnDefs] = useState(null);
  const [activeSession, setActiveSession] = useState(null);

  function clickHandler() {
    setIsDialog(true);
    getSpecularProjectsAsync(props.selectedProject[0].id);
  }

  const [rowData, setRowData] = useState(null);
  useEffect(() => {
    if (lookUpData && specularProjects) {
      const allColumns = [
        {
          headerName: 'Year',
          field: 'year',
          filter: false,
          sortable: false,
          cellStyle: { color: 'grey' },
          hide: true,
          width: 80
        },
        {
          headerName: 'Project Log ID',
          field: 'specular id',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            //clearButton: true,
            //cancelButton: true, ???
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          width: 130
        },
        {
          headerName: 'Project ID',
          field: 'id',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          width: 100
        },
        {
          headerName: 'Current Session',
          field: 'current session',
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { display: 'none' } }
        },
        {
          headerName: 'Planned Value',
          field: 'planned value',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Version Total',
          field: 'version total',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders',
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Locked',
          field: 'isLocked',
          filter: true,
          sortable: true,
          width: 100,
          cellRenderer: (params) => params.data.isLocked ? '&#x1f6c7' : null
        },
        {
          headerName: 'SAP Initiative',
          field: 'sap initiative',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellRenderer: allowOnlyDigits
        },
        {
          headerName: 'Domain',
          field: 'domain',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Sub Domain',
          field: 'sub domain',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Project Name',
          field: 'project name',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          tooltipField: 'project name'
        },
        {
          headerName: "IT Owner",
          field: "it owner",
          filter: "agSetColumnFilter"
        },
        {
          headerName: "Sub Owner",
          field: "sub owner",
          filter: "agSetColumnFilter"
        },
        {
          headerName: 'Business Owner',
          field: 'business owner',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
        },
        {
            headerName: 'Target region',
            field: 'target region',
            filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Customer',
          field: 'customer',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Sub Customer',
          field: 'sub-customer',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Goal',
          field: 'goal',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Timing',
          field: 'timing',
          filter: 'agSetColumnFilter',
          cellStyle: { color: 'grey' }
        },
        {
          headerName: 'Priority',
          field: 'priority',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Nature',
          field: 'nature',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Investment mix',
          field: 'investment mix',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Mandatory',
          field: 'mandatory',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Methodology',
          field: 'methodology',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Digital spending',
          field: 'digital',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Project Approval',
          field: 'project approval',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Project Phase',
          field: 'project phase',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Progress %',
          field: 'progress',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellRenderer: allowOnlyDigits
        },
        {
          headerName: 'Project KO value',
          field: 'project ko',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Connected Costs',
          field: 'connected costs',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'H/W Connected Investments',
          field: 'h/w connected investments',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L01',
          field: 'l01',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueSetter: params => valueHasChanged(params),
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-D1',
          field: 'l01-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueSetter: params => valueHasChanged(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-S1',
          field: 'l01-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l01) + Number(data[`l01-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L01-D2',
          field: 'l01-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueSetter: params => valueHasChanged(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-S2',
          field: 'l01-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l01) + Number(data[`l01-d1`]) + Number(data[`l01-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L01-D3',
          field: 'l01-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueSetter: params => valueHasChanged(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L01-RO',
          field: 'l01-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l01) + Number(data[`l01-d1`]) + Number(data[`l01-d2`]) + Number(data[`l01-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03',
          field: 'l03',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-D1',
          field: 'l03-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-S1',
          field: 'l03-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l03) + Number(data[`l03-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03-D2',
          field: 'l03-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-S2',
          field: 'l03-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l03) + Number(data[`l03-d1`]) + Number(data[`l03-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L03-D3',
          field: 'l03-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L03-RO',
          field: 'l03-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l03) + Number(data[`l03-d1`]) + Number(data[`l03-d2`]) + Number(data[`l03-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06',
          field: 'l06',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-D1',
          field: 'l06-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-S1',
          field: 'l06-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l06) + Number(data[`l06-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06-D2',
          field: 'l06-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-S2',
          field: 'l06-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l06) + Number(data[`l06-d1`]) + Number(data[`l06-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L06-D3',
          field: 'l06-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L06-RO',
          field: 'l06-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l06) + Number(data[`l06-d1`]) + Number(data[`l06-d2`]) + Number(data[`l06-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L12',
          field: 'l12',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-D1',
          field: 'l12-d1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-S1',
          field: 'l12-s1',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l12) + Number(data[`l12-d1`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L12-D2',
          field: 'l12-d2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-S2',
          field: 'l12-s2',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l12) + Number(data[`l12-d1`]) + Number(data[`l12-d2`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'L12-D3',
          field: 'l12-d3',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueFormatter: params => currencyFormatter(params)
        },
        {
          headerName: 'L12-RO',
          field: 'l12-ro',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueGetter: 'Number(data.l12) + Number(data[`l12-d1`]) + Number(data[`l12-d2`]) + Number(data[`l12-d3`])',
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Commitment',
          field: 'commitment',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders',
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Actual',
          field: 'actual',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders',
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Project Final Value',
          field: 'project final value',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Estimation',
          field: 'estimation',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          valueSetter: params => valueHasChanged(params),
          valueFormatter: params => currencyFormatter(params),
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } }
        },
        {
          headerName: 'Rebilling',
          field: 'rebilling',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Release Date',
          field: 'release date',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Project Life',
          field: 'project life',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          }
        },
        {
          headerName: 'Project Status',
          field: 'project status',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Portfolio Mix',
          field: 'portfolio mix',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'Responsibility Center',
          field: 'responsibility center',
          filter: 'agSetColumnFilter'
        },
        {
          headerName: 'YTG',
          field: 'ytg',
          filter: 'agNumberColumnFilter',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
          pinnedRowCellRenderer: 'customPinnedRowRenderer',
          pinnedRowCellRendererParams: { style: { color: 'grey' } },
          valueGetter: `data['version total'] - data.actual - data.commitment`,
          valueFormatter: params => currencyFormatter(params),
          headerClass: 'yellowHeaders'
        },
        {
          headerName: 'Notes',
          field: 'notes',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          headerClass: 'yellowHeaders',
          tooltipField: 'notes'
        },
        {
          headerName: 'Last Modified Date',
          field: 'last modified date',
          cellStyle: { color: 'grey' },
          comparator: dateComparator,
          filter: 'agDateColumnFilter',
          filterParams: {
            comparator: function (filterLocalDateAtMidnight, cellValue) {
              const dateParts = cellValue.split(' ')[0].split('/');

              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );

              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime())
                return 0;

              if (cellDate < filterLocalDateAtMidnight)
                return -1;

              if (cellDate > filterLocalDateAtMidnight)
                return 1;
            }
          }
        },
        {
          headerName: 'Last Modified By',
          field: 'last modified by',
          filterParams: {
            applyButton: true,
            resetButton: true,
            closeOnApply: true
          },
          cellStyle: { color: 'grey' },
        }
      ];

      //cannot use directly setColumnDefs(allColumns)
      if (gridApi)
        gridApi.setColumnDefs(allColumns);

      const projectsData = [];

      if (specularProjects.length > 0) {
        specularProjects.map(specularProject => {
          const domainString = getDataValue(specularProject.domainId, lookUpData.domains);
          const subDomainString = getDataValue(specularProject.subDomainId, lookUpData.subDomains);
          const timingString = getDataValue(specularProject.timingId, lookUpData.timings);
          const customerString = getDataValue(specularProject.customerId, lookUpData.customers);
          const subCustomerString = getDataValue(specularProject.subCustomerId, lookUpData.subCustomers);
          const goalString = getDataValue(specularProject.goalId, lookUpData.goals);
          const priorityString = getDataValue(specularProject.priorityId, lookUpData.priorities);
          const natureString = getDataValue(specularProject.natureId, lookUpData.natures);
          const investmentString = getDataValue(specularProject.investmentMixId, lookUpData.investmentMixes);
          const mandatoryString = getDataValue(specularProject.mandatoryId, lookUpData.mandatories);
          const methodologyString = getDataValue(specularProject.methodologyId, lookUpData.methodologies);
          const digitalString = getDataValue(specularProject.digitalId, lookUpData.digitals);
          const prLivesString = getDataValue(specularProject.projectLifeId, lookUpData.projectLives);
          const prStatusString = getDataValue(specularProject.projectStatusId, lookUpData.projectStatus);
          const portfolioString = getDataValue(specularProject.portfolioMixId, lookUpData.portfolioMixes);
          const responsibilityString = getDataValue(specularProject.responsibilityCenterId, lookUpData.responsibilityCenters);
          const prApprovalString = getDataValue(specularProject.projectApprovalId, lookUpData.projectApprovals);
          const prPhaseString = getDataValue(specularProject.projectPhaseId, lookUpData.projectPhases);
          const targetString = getDataValue(specularProject.targetId, lookUpData.targets);
          const rebillingString = getDataValue(specularProject.rebillingId, lookUpData.rebillings, "Rebilling");
          const releaseDateString = getDataValue(specularProject.releaseDateId, lookUpData.releaseDates, "Release Date");

          let lastModifiedDate = null;
          if (specularProject.updateDate) {
            const checkDate = specularProject.updateDate.indexOf('Z') !== -1 ? specularProject.updateDate : specularProject.updateDate + "Z";
            const date = new Date(checkDate);
            lastModifiedDate = moment(date).format("DD/MM/YYYY H:mm:ss");
          }

          const budgetSessionValue = ["L01","L01-D1","L01-D2","L01-D3","L03","L03-D1","L03-D2","L03-D3","L06","L06-D1","L06-D2","L06-D3","L12","L12-D1","L12-D2","L12-D3"];

          projectsData.push({
            'specular id': specularProject.specularProjectId,
            id: specularProject.projectId,
            'project name': specularProject.name,
            //ownerKey: "06de1b39-9190-4ed2-a90b-2ab01dab035d"
            'it owner': specularProject.ownerFullName,
            'sub owner': specularProject.subOwnerFullName,
            'business owner': specularProject.businessOwner,
            year: specularProject.year,
            'sap initiative': specularProject.sapInitiative,
            domain: domainString,
            'sub domain': subDomainString,
            'target region': targetString,
            customer: customerString,
            'sub-customer': subCustomerString,
            goal: goalString,
            timing: timingString,
            priority: priorityString,
            nature: natureString,
            'investment mix': investmentString,
            mandatory: mandatoryString,
            methodology: methodologyString,
            digital: digitalString,
            'project life': prLivesString,
            'project status': prStatusString,
            'portfolio mix': portfolioString,
            'responsibility center': responsibilityString,
            'project approval': prApprovalString,
            'project phase': prPhaseString,
            rebilling: rebillingString,
            progress: specularProject.progress,
            estimation: specularProject.estimation,
            'project ko': specularProject.projectKO,
            'connected costs': specularProject.connectedCosts,
            'h/w connected investments': specularProject.hardwareConnectedInvestments,
            l01: specularProject.l01,
            'l01-d1': specularProject.l01D1,
            'l01-d2': specularProject.l01D2,
            'l01-d3': specularProject.l01D3,
            l03: specularProject.l03,
            'l03-d1': specularProject.l03D1,
            'l03-d2': specularProject.l03D2,
            'l03-d3': specularProject.l03D3,
            l06: specularProject.l06,
            'l06-d1': specularProject.l06D1,
            'l06-d2': specularProject.l06D2,
            'l06-d3': specularProject.l06D3,
            l12: specularProject.l12,
            'l12-d1': specularProject.l12D1,
            'l12-d2': specularProject.l12D2,
            'l12-d3': specularProject.l12D3,
            'project final value': specularProject.projectFinalValue,
            commitment: specularProject.committment,
            actual: specularProject.actual,
            notes: specularProject.notes,
            'current session': budgetSessionValue[specularProject.currentSessionId - 1],
            'planned value': specularProject.plannedValue,
            'version total': specularProject.versionTotal,
            'release date': releaseDateString,
            'last modified date': lastModifiedDate,
            'last modified by': specularProject.updatedByFullName,
            'isLocked': specularProject.isLocked
          });
        });
      }
      
      setRowData(projectsData);
    }
  }, [specularProjects])

  /*useEffect(() => {
    if (rowData !== null) {
      updateTopRowSum();
    }
  }, [rowData])*/

  function updateTopRowSum() {
    let projectKOSum = null;
    let connectedCostsSum = null;
    let HWInvestmentsSum = null;
    let l01Sum = null;
    let l01D1Sum = null;
    let l01S1Sum = null;
    let l01D2Sum = null;
    let l01S2Sum = null;
    let l01D3Sum = null;
    let l01ROSum = null;
    let l03Sum = null;
    let l03D1Sum = null;
    let l03S1Sum = null;
    let l03D2Sum = null;
    let l03S2Sum = null;
    let l03D3Sum = null;
    let l03ROSum = null;
    let l06Sum = null;
    let l06D1Sum = null;
    let l06S1Sum = null;
    let l06D2Sum = null;
    let l06S2Sum = null;
    let l06D3Sum = null;
    let l06ROSum = null;
    let l12Sum = null;
    let l12D1Sum = null;
    let l12S1Sum = null;
    let l12D2Sum = null;
    let l12S2Sum = null;
    let l12D3Sum = null;
    let l12ROSum = null;
    let estimationSum = null;
    let commitmentSum = null;
    let actualSum = null;
    let prFinalValue = null;
    let ytgValue = null;
    let plannedValue = null;
    let versionTotalSum = null;

    gridApi.forEachNodeAfterFilter(function (rowNode, index) {
      if (rowNode.data) {
        projectKOSum += Number(rowNode.data['project ko']);
        connectedCostsSum += Number(rowNode.data['connected costs']);
        HWInvestmentsSum += Number(rowNode.data['h/w connected investments']);
        l01Sum += Number(rowNode.data.l01);
        l01D1Sum += Number(rowNode.data['l01-d1']);
        l01S1Sum += (Number(rowNode.data.l01) + Number(rowNode.data['l01-d1']));
        l01D2Sum += Number(rowNode.data['l01-d2']);
        l01S2Sum += (Number(rowNode.data.l01) + Number(rowNode.data['l01-d1']) + Number(rowNode.data['l01-d2']));
        l01D3Sum += Number(rowNode.data['l01-d3']);
        l01ROSum += (Number(rowNode.data.l01) + Number(rowNode.data['l01-d1']) + Number(rowNode.data['l01-d2']) + Number(rowNode.data['l01-d3']));
        l03Sum += Number(rowNode.data.l03);
        l03D1Sum += Number(rowNode.data['l03-d1']);
        l03S1Sum += (Number(rowNode.data.l03) + Number(rowNode.data['l03-d1']));
        l03D2Sum += Number(rowNode.data['l03-d2']);
        l03S2Sum += (Number(rowNode.data.l03) + Number(rowNode.data['l03-d1']) + Number(rowNode.data['l03-d2']));
        l03D3Sum += Number(rowNode.data['l03-d3']);
        l03ROSum += (Number(rowNode.data.l03) + Number(rowNode.data['l03-d1']) + Number(rowNode.data['l03-d2']) + Number(rowNode.data['l03-d3']));
        l06Sum += Number(rowNode.data.l06);
        l06D1Sum += Number(rowNode.data['l06-d1']);
        l06S1Sum += (Number(rowNode.data.l06) + Number(rowNode.data['l06-d1']));
        l06D2Sum += Number(rowNode.data['l06-d2']);
        l06S2Sum += (Number(rowNode.data.l06) + Number(rowNode.data['l06-d1']) + Number(rowNode.data['l06-d2']));
        l06D3Sum += Number(rowNode.data['l06-d3']);
        l06ROSum += (Number(rowNode.data.l06) + Number(rowNode.data['l06-d1']) + Number(rowNode.data['l06-d2']) + Number(rowNode.data['l06-d3']));
        l12Sum += Number(rowNode.data.l12);
        l12D1Sum += Number(rowNode.data['l12-d1']);
        l12S1Sum += (Number(rowNode.data.l12) + Number(rowNode.data['l12-d1']));
        l12D2Sum += Number(rowNode.data['l12-d2']);
        l12S2Sum += (Number(rowNode.data.l12) + Number(rowNode.data['l12-d1']) + Number(rowNode.data['l12-d2']));
        l12D3Sum += Number(rowNode.data['l12-d3']);
        l12ROSum += (Number(rowNode.data.l12) + Number(rowNode.data['l12-d1']) + Number(rowNode.data['l12-d2']) + Number(rowNode.data['l12-d3']));
        estimationSum += Number(rowNode.data.estimation);
        commitmentSum += Number(rowNode.data.commitment);
        actualSum += Number(rowNode.data.actual);
        prFinalValue += Number(rowNode.data['project final value']);
        ytgValue += ((Number(rowNode.data[`l${activeSession}`]) + Number(rowNode.data[`l${activeSession}-d1`]) + Number(rowNode.data[`l${activeSession}-d2`]) + Number(rowNode.data[`l${activeSession}-d3`])) - Number(rowNode.data.actual) - Number(rowNode.data.commitment));
        plannedValue += Number(rowNode.data['planned value']);
        versionTotalSum += Number(rowNode.data['version total']);
      }
    });
    
    const row = [{
      'project ko': currencyFormatter(projectKOSum),
      'connected costs': currencyFormatter(connectedCostsSum),
      'h/w connected investments': currencyFormatter(HWInvestmentsSum),
      l01: currencyFormatter(l01Sum),
      'l01-d1': currencyFormatter(l01D1Sum),
      'l01-s1': currencyFormatter(l01S1Sum),
      'l01-d2': currencyFormatter(l01D2Sum),
      'l01-s2': currencyFormatter(l01S2Sum),
      'l01-d3': currencyFormatter(l01D3Sum),
      'l01-ro': currencyFormatter(l01ROSum),
      l03: currencyFormatter(l03Sum),
      'l03-d1': currencyFormatter(l03D1Sum),
      'l03-s1': currencyFormatter(l03S1Sum),
      'l03-d2': currencyFormatter(l03D2Sum),
      'l03-s2': currencyFormatter(l03S2Sum),
      'l03-d3': currencyFormatter(l03D3Sum),
      'l03-ro': currencyFormatter(l03ROSum),
      l06: currencyFormatter(l06Sum),
      'l06-d1': currencyFormatter(l06D1Sum),
      'l06-s1': currencyFormatter(l06S1Sum),
      'l06-d2': currencyFormatter(l06D2Sum),
      'l06-s2': currencyFormatter(l06S2Sum),
      'l06-d3': currencyFormatter(l06D3Sum),
      'l06-ro': currencyFormatter(l06ROSum),
      l12: currencyFormatter(l12Sum),
      'l12-d1': currencyFormatter(l12D1Sum),
      'l12-s1': currencyFormatter(l12S1Sum),
      'l12-d2': currencyFormatter(l12D2Sum),
      'l12-s2': currencyFormatter(l12S2Sum),
      'l12-d3': currencyFormatter(l12D3Sum),
      'l12-ro': currencyFormatter(l12ROSum),
      estimation: currencyFormatter(estimationSum),
      commitment: currencyFormatter(commitmentSum),
      actual: currencyFormatter(actualSum),
      'project final value': currencyFormatter(prFinalValue),
      ytg: currencyFormatter(ytgValue),
      'planned value': currencyFormatter(plannedValue),
      'version total': currencyFormatter(versionTotalSum)
    }];

    gridApi.setPinnedTopRowData(row);
  }

  function getDataValue(dbProject, lookupField, extraField) {
    let value = null;

    if (lookupField.length > 0) {
      if (extraField) {
        let cache = {};
        const doubles = [];
        for (let i = 0; i < lookupField.length; i++) {
          if (cache[lookupField[i].title] === true)
            doubles.push(lookupField[i].title);
          else
            cache[lookupField[i].title] = true;
        }

        const doubleObjects = [];
        lookupField.map(lookupData => {
          doubles.map(double => {
            if (lookupData.title === double)
              doubleObjects.push(lookupData);
          })
        });

        doubleObjects.map(double => {
          if (double.id === dbProject)
            value = double.title + " " + (extraField === "Rebilling" || extraField === "Release Date" ? double.customId : double.code);
        });

        if (!value)
          lookupField.map(lookupData => {
            if (dbProject === lookupData.id)
              value = lookupData.title;
          });
      }

      else
        lookupField.map(lookupData => {
          if (dbProject === lookupData.id)
            value = lookupData.title;
        });
    }

    return value;
  }

  const [defaultColDef, setDefaultColDef] = useState({
    filter: 'agTextColumnFilter',
    sortable: true,
    editable: false,
    cellStyle: { color: 'grey' },
    resizable: true
  });

  const [sideBar, setSideBar] = useState({
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel'
      },
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel'
      }
    ],
    position: 'left'
  });

  const [components, setComponents] = useState({
    datePicker: getDatePicker()
  });
  const [frameworkComponents, setFrameworkComponents] = useState({
    customPinnedRowRenderer: CustomPinnedRowRenderer
  });

  function getDatePicker() {
    // function to act as a class
    function Datepicker() { }

    // gets called once before the renderer is used
    Datepicker.prototype.init = function (params) {
      // create the cell
      eInput = document.createElement('input');
      eInput.value = params.value;
      eInput.style.height = '100%';
      eInput.style.width = '100%';

      //IE doesn't support <input type="date" />
      if (!window.document.documentMode)
        eInput.type = "date";
    };

    // gets called once when grid ready to insert the element
    Datepicker.prototype.getGui = function () {
      return eInput;
    };

    // focus and select can be done after the gui is attached
    Datepicker.prototype.afterGuiAttached = function () {
      eInput.focus();
      eInput.select();
    };

    // returns the new value after editing
    Datepicker.prototype.getValue = function () {
      return eInput.value;
    };

    // any cleanup we need to be done here
    Datepicker.prototype.destroy = function () {
      // but this example is simple, no cleanup, we could
      // even leave this method out as it's optional
    };

    // if true, then this editor will appear in a popup
    Datepicker.prototype.isPopup = function () {
      // and we could leave this method out also, false is the default
      return false;
    };

    return Datepicker;
  }

  function dateComparator(date1, date2) {
    const date1Number = dateConverter(date1);
    const date2Number = dateConverter(date2);

    if (date1Number === null && date2Number === null)
      return 0;

    if (date1Number === null)
      return -1;

    if (date2Number === null)
      return 1;

    return date1Number - date2Number;
  }

  function dateConverter(date) {
    if (date === undefined || date === null)
      return null;

    const year = date.split(" ")[0].split("/")[2];
    const month = date.split(" ")[0].split("/")[1];
    const day = date.split(" ")[0].split("/")[0];
    const hours = date.split(" ")[1].split(":")[0];
    const minutes = date.split(" ")[1].split(":")[1];
    const seconds = date.split(" ")[1].split(":")[2];

    return new Date(year, month, day, hours, minutes, seconds);
  }

  function valueHasChanged(params) {
    const field = params.colDef.field;
    //0 is considered a null value and valueGetter doesn't get triggered so I turned 0 in a string (that changes for valueGetters but not for UI)
    const value = params.newValue == "0" ? "0 " : Number(params.newValue);

    if (field === "progress") {
      if (String(value).indexOf(".") == -1)
        return params.data.progress = value;
      else
        return params.data.progress = null;
    }
    else
      return params.data[field] = value;
  }

  function allowOnlyDigits(params) {
    if (Number(params.value) || params.value == "0 ")
      return params.value;
    else
      return null;
  }

  function currencyFormatter(params) {
    if (params || params == 0) {
      const formatter = new Intl.NumberFormat('en-US', {//it-IT
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });

      if (Number(params.value) || params.value === 0 || params.value == "0 ") {
        const checkValue = params.value == "0 " ? formatter.format(0) : formatter.format(params.value);
        return params.value || params.value === 0 ? checkValue : "";
      }

      //top row sums
      else if (!params.value)
        return Number(params) || params === 0 ? formatter.format(params) : "";

      else
        return "";
    }
  }

  return (
    <>
      <Button
        color="primary"
        size="small"
        variant="contained"
        style={{ marginRight: '15px', fontSize: '11px' }}
        onClick={clickHandler}
        disabled={
          !props.selectedProject ||
          props.selectedProject.length !== 1 ||
          !props.selectedProject[0].id
        }
      >Previous Budget Sessions</Button>
      <Dialog
        open={isDialog}
        onClose={() => closeDialog()}
        aria-labelledby="form-dialog-title"
      >
        <div className="ag-theme-balham" style={{ height: '100%', overflow: 'hidden' }}>
          <div className={classes.gridContainer}>
            <AgGridReact
              defaultColDef={defaultColDef}
              columnDefs={columnDefs}
              rowDeselection={true}
              rowData={rowData}
              animateRows={true}
              suppressRowClickSelection={true}
              enableRangeSelection={true}
              enableFillHandle={true}
              sideBar={sideBar}
              onGridReady={params => {
                gridApi = params.api;
                gridApi.showLoadingOverlay();
              }}
              suppressColumnVirtualisation={true}
              multiSortKey={'ctrl'}
              rowSelection="single"
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}